module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ge-3c65f52fda94c4461ae5012db03442bb.svg";